import { normalizeError } from '../../types/errors/errors';

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    throw normalizeError(response);
  }

  // Handle empty responses
  const contentLength = response.headers.get('content-length');
  if (contentLength === '0' || response.status === 204) {
    return undefined as T;
  }

  return response.json();
}

export interface RequestOptions extends Omit<RequestInit, 'body'> {
  body?: unknown;
}

export const httpClient = {
  async get<T>(url: string, options?: RequestOptions): Promise<T> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { body, ...fetchOptions } = options ?? {};
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'GET'
    });
    return handleResponse<T>(response);
  },

  async post<T>(url: string, options?: RequestOptions): Promise<T> {
    const { body, ...fetchOptions } = options ?? {};
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...fetchOptions.headers
      },
      body: body ? JSON.stringify(body) : undefined
    });
    return handleResponse<T>(response);
  },

  async patch<T>(url: string, options?: RequestOptions): Promise<T> {
    const { body, ...fetchOptions } = options ?? {};
    const response = await fetch(url, {
      ...fetchOptions,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...fetchOptions.headers
      },
      body: body ? JSON.stringify(body) : undefined
    });
    return handleResponse<T>(response);
  }
};
